import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/home/services/home.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Location, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { timestampFormat } from '../../../../../app/config/moment';
import { DesktopDevicesModalComponent } from '../desktop-devices-modal/desktop-devices-modal.component';

@Component({
  selector: 'app-desktoplist-devices',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './desktoplist-devices.component.html',
  styleUrls: ['./desktoplist-devices.component.scss', '../../../../app.component.scss']
})
export class DesktoplistDevicesComponent implements OnInit {
  public totalEntriesCount: number = 0;
  public desktopdetail: any = [];
  public storeName: string = '';
  public storeId: string = '';
  public devicesId: string = '';
  public timestampFormat = timestampFormat;
  public u_name: string = '';
  public lastAccessed: string = '';
  public deviceName: string = ''
  public desktoplist: any = [];
  desktop: any;
  public isSearch = false;
  public isFilter = false;
  
  public isFilterResult = true;

  public orderBy:string = "asc";

  public stockValue: string;
  public users: string;
  cabinetService: any;
  public userNamesList: any = [];
  public selectedUserNames: any = [];
  public isUserNames: boolean = false;
  username: any;

  public search: string;
  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public selectedStatus = [];

  constructor(
    private router: Router, 
    public route: ActivatedRoute,
    public dialog: MatDialog,
    private spinnerService: NgxSpinnerService,
    public location: Location,
    public homeService: HomeService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.storeId = params['storeId'];
      this.devicesId = params['deviceId'];
      this.getDesktopSummary(this.storeId, this.devicesId, this.stockValue, this.selectedUserNames);
      this.getDesktopDevice(this.storeId);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.u_name = queryParams['u_name'];
      this.lastAccessed = queryParams['last_updated_at'];
    });
  }

  onFilterChange() {
    this.getDesktopSummary(this.storeId, this.devicesId, this.stockValue, this.selectedUserNames, this.encodedSearchInput);
  }

  getDesktopSummary(storeId: string, devicesId: string, stockValue: string = "", users: Array<string> = [], search: string = "") {
    this.homeService.getDesktopSummary(storeId, devicesId, stockValue, users, search).subscribe((res: any) => {
      if (res.data) {
        this.desktopdetail = res.data.data;
      }
    });
  }

  openDotPopup(event){
    document.getElementById("dots-popup").classList.toggle("active");
    // $("#dots-popup").toggleClass("active");
    event.stopPropagation()

    this.closePopupOutside("dots-popup");
  }

  onSearchSubmit() {
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false;
        this.isFilterResult = true; 
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getDesktopSummary(this.storeId, this.devicesId, this.stockValue, this.selectedUserNames, this.encodedSearchInput); 
    }
  }

  reset(event: Event) {
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getDesktopSummary(this.storeId, this.devicesId, this.stockValue);
    }
  }

  raisedAtSort(){
    this.isFilter = true;

    if (this.stockValue === "asc") {
      this.stockValue = "desc";
    }else{
      this.stockValue = this.orderBy;
    }

    this.onFilterChange();
  }

  resetSearch(): void {
    this.deviceName = '';
    this.getDesktopSummary(this.storeId, this.devicesId, this.stockValue, this.selectedUserNames);
  }

  searchByDesktopName(): void {
    this.desktopdetail = this.desktopdetail.filter((desktop: any) =>
      desktop.name.toLowerCase().includes(this.deviceName.toLowerCase())
    );
  }

  getCabinetUsers() {
    this.cabinetService.getCabinetUsers(this.currentCabinetId, "names").subscribe(res => {
      if (res.data.length !== 0) {
        this.isUserNames = true;
        this.userNamesList = res.data;
      } else {
        this.isUserNames = false;
      }
    });
  }
  currentCabinetId(currentCabinetId: any, arg1: string) {
    throw new Error('Method not implemented.');
  }
  
  openActionPopup(event){
    document.getElementById("action-popup").classList.toggle("active");

    event.stopPropagation()

    this.closePopupOutside("action-popup");
  }

  onUserFilterChange(event){
    if (event.target.checked) {
      this.selectedUserNames.push(event.target.value);
    }else{
      this.selectedUserNames = this.selectedUserNames.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;
    this.onFilterChange();    
  }

  openUsersPopup(event){
    document.getElementById("users-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("users-popup");
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  getDesktopDownload(storeId: string, devicesId: string){
    if (storeId) {
      this.homeService.getDesktopSummary(storeId, devicesId, this.stockValue).subscribe((res) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(res);
        link.download = `${storeId}`;
        link.click(); 
      });
    } else {
      console.error('StoreId or type is undefined or null');
    }
  }

  openPopup(event: MouseEvent) {
    let openedPopup = document.getElementsByClassName("dots-popup");
    let targetedElement = (event.target as HTMLElement).closest('td');
    let popupDiv = targetedElement.querySelector(".dots-popup") as HTMLElement;
    Array.from(openedPopup).forEach((el) => {
      if (el !== popupDiv) {
        el.classList.remove('active');
      }
    });
    popupDiv.classList.toggle("active");
    event.stopPropagation();
    document.addEventListener('click', function (event: any) {
      if (popupDiv.classList.contains("active") && !popupDiv.contains(event.target)) {
        popupDiv.classList.remove("active");
      }
    }, { once: true });

  }

  openDialog(desktopName: string, type: string): void {
    const dialogRef = this.dialog.open(DesktopDevicesModalComponent, {
      data: {
        name: desktopName,
        device_id: this.devicesId,
        type: type,
      }
    });
  
    // dialogRef.afterClosed().subscribe(result => {
    //   if (type === 'u_name' && result) {
    //     const editedDesktop = this.desktopdetail.find(d => d.device_id === this.devicesId);
    //     if (editedDesktop) {
    //       editedDesktop.u_name = result;
    //     }
    //   }
    // });
    dialogRef.afterClosed().subscribe(result => {
      if (type === 'u_name' && result) {
        this.desktopdetail.u_name = result;
      }
    });
  }
    
  getDesktopDevice(storeId: string, descValue: string = "", search: string = "",stockReadValue: string = "") {
    this.homeService.getDesktopDevice(storeId,descValue,search,stockReadValue).subscribe((res: any) => {
      if (res.data) {
        this.desktoplist = res.data.data;
      }
    });
  }

  goBack() {
    this.location.back();
  }
}
